module.exports = __webpack_public_path__ + "img/logo-zcy@3x.33e7af4a.png";